import type { ChatMessage } from './types';

/**
 * Monta o `reply_to` (a citação) pra bolha OTIMISTA de uma resposta, a partir
 * da mensagem que o atendente está respondendo.
 *
 * O painel já tem a mensagem-alvo inteira em mãos (o `replyingTo`), então dá
 * pra pintar a citação na hora do envio — sem depender do eco do servidor.
 *
 * O bug que isto fecha (relatado pelo dono): a resposta "não fica marcada na
 * nossa conversa, apenas para o cliente". A bolha otimista nascia SEM
 * `reply_to`; a citação só aparecia se o eco do servidor chegasse e a
 * completasse. O cliente sempre via (a Meta cita pela wamid), mas do nosso lado
 * dependia de um eco que pode nem chegar (fora da sala da conversa). O servidor
 * devolve o MESMO shape no eco — a idempotência do dedup absorve a segunda via.
 *
 * Só cita se a alvo tem `wamid`: o WhatsApp quota por wamid, e sem ele não há o
 * que referenciar.
 */
export function snapshotDaResposta(alvo: ChatMessage | null): Partial<ChatMessage> {
  if (!alvo?.wamid) return {};
  return {
    reply_to_wamid: alvo.wamid,
    reply_to: {
      wamid: alvo.wamid,
      body: alvo.body,
      type: alvo.type,
      direction: alvo.direction,
    },
  };
}
